export default __webpack_public_path__ + "static/media/transfer-send-album.22940e4f.png";